import {Grid, Typography} from "@mui/material";
import {CardContainerTitle} from "components/CardContainerTitle";
import React from "react";
import {useTranslation} from "react-i18next";
import {StadiumTicketCounter} from "./StadiumTicketCounter";

export function StadiumTicketBuySpots() {
	const {t} = useTranslation();

	return (
		<Grid container spacing={1}>
			<Grid item>
				<CardContainerTitle title={t("club.stadium.ticketOffices")}/>
			</Grid>
			<StadiumTicketCounter name={"A"} location={t("club.stadium.south")}
			                      description={t("club.stadium.twoSalesPoints")}/>
			<StadiumTicketCounter name={"B"} location={t("club.stadium.north")}
			                      description={t("club.stadium.oneSalesPoint")}/>
			<StadiumTicketCounter name={"C"} location={t("club.stadium.north")}
			                      description={t("club.stadium.oneSalesPointVipPress")}/>
			<StadiumTicketCounter name={"D"} location={t("club.stadium.south")}
			                      description={t("club.stadium.salesPointSouthTribune")}/>
			<Grid item>
				<Typography variant={"bodyS"}>{t("club.stadium.ticketOfficeOpeningTime")}</Typography>
			</Grid>
		</Grid>
	)
}
